const button = {
  variants: [
    /* Contained */
    {
      props: { variant: 'contained', size: 'small'},
      style: ({ theme }) => ({
        color: theme.palette.base.white,
        padding: theme.spacing(0.50, 1.25), // 4px 10px
        borderRadius: theme.shape.borderRadius,
        ...theme.typography.caption,
        fontWeight: 500,
      }),
    },
    {
      props: { variant: 'contained', size: 'medium' },
      style: ({ theme }) => ({
        height: 'auto',
        width: 'auto',
        color: theme.palette.base.white,
        padding: theme.spacing(0.75, 2), // 6px 16px
        borderRadius: theme.shape.borderRadius,
        ...theme.typography.regular,
      }),
    },
    {
      props: { variant: 'contained', size: 'large'},
      style: ({ theme }) => ({
        height: '3rem',
        width: 'auto',
        color: theme.palette.base.white,
        padding: theme.spacing(1, 2.75), // 8px 22px
        borderRadius: theme.shape.borderRadius,
        ...theme.typography.body2,
        fontWeight: 500,
      }),
    },
    {
      props: { variant: 'outlined'},
      style: ({ theme }) => ({
        // borderColor: theme.palette.primary.main,
        // color: theme.palette.primary.main,
        fontWeight: theme.typography.button.fontWeight,
        // '&:hover': {
        //   backgroundColor: theme.palette.action.hover,
        // },
      }),
    },
    {
      props: { variant: 'text' },
      style: ({ theme }) => ({
        color: theme.palette.primary.main,
        fontWeight: theme.typography.button.fontWeight,
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'none',
      boxShadow: 'none',
      borderRadius: theme.shape.borderRadius,
    }),
  },
};

export default button;